export default "__VITE_ASSET__55465257__"